module.exports = __webpack_public_path__ + "static/media/driver.776669bc.svg";